import React from "react";
import { useIntl } from "react-intl";
import Header from "../../modules/layout/components/Header";
import ContactBar from "../../modules/layout/components/ContactBar";
import Footer from "../../modules/layout/components/Footer";
import CategoryList from "../../modules/categories/components/CategoryList";
import { preFetchCategories } from "../../modules/categories/hooks/useCategories";
import {
  addApolloState,
  initializeApollo,
} from "../../modules/apollo/apolloClient";
import { navigationQueries } from "../../modules/ssgHelpers/sharedPageData";
import { preFetchCMSPage } from "modules/navigation/hooks/useCMSPage";
import LayoutRenderer from "modules/getcockpit/components/LayoutRenderer";
import LocalizedHead from "modules/navigation/components/LocalizedHead";
import { findPageIdByFilePath } from "modules/common/utils/findPageIdByFilePath";
import { getLocalizedRoute } from "modules/layout/components/LocalizedLink";

const Shop = ({ currentPage }) => {
  const intl = useIntl();

  return (
    <>
      <Header />
      <LocalizedHead
        fallbackTitle={currentPage?.title}
        routes={currentPage?._routes}
        {...currentPage}
      />
      <div className="container mt-5">
        <ContactBar />
        <h1>
          {intl.formatMessage({
            id: "sortiment",
            defaultMessage: "Sortiment",
          })}
        </h1>

        {currentPage?.data?.layoutList?.before && (
          <LayoutRenderer layout={currentPage.data.layoutList.before} />
        )}
        <CategoryList />
        {currentPage?.data?.layoutList?.after && (
          <LayoutRenderer layout={currentPage.data.layoutList.after} />
        )}
      </div>
      <Footer />
    </>
  );
};

export async function getStaticProps({ locale }) {
  if (locale === process.env.NEXT_PUBLIC_FAKE_LOCALE) {
    return {
      notFound: true,
    };
  }
  const apolloClient = await initializeApollo(null, { locale });
  await navigationQueries(apolloClient, locale);

  const pageId = findPageIdByFilePath("/shop");

  const { route } = await getLocalizedRoute(apolloClient, { pageId }, locale);

  const currentPage = await preFetchCMSPage(apolloClient, {
    locale,
    route,
  });

  await preFetchCategories(apolloClient, {
    locale,
  });

  return addApolloState(apolloClient, {
    props: { currentPage },
    revalidate: 180,
  });
}

export default Shop;
